import { Select, SelectList } from "./Select";
import * as React from "react";
import { ReactElement } from "react";
import { useProjects } from "../core/hooks/useProjects";

export interface SelectProjectProps {
  onChange: (project: string) => void;
  project: string;
}

export function SelectProject({
  project,
  onChange,
}: SelectProjectProps): ReactElement {
  const { data } = useProjects();

  const projects: SelectList = React.useMemo(
    () =>
      (data?.projects ?? [])
        .filter((p) => p.status === "ENABLED")
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((p) => ({ value: p.name, label: p.name })),
    [data]
  );

  return (
    <Select
      label="Countries"
      value={project}
      onChange={onChange}
      list={projects}
    />
  );
}
